module.exports = __webpack_public_path__ + "img/icon-home.ca04bad6.svg";